<ng-template #modalfilter>
  <div class="modal-header">
    <h4 class="modal-title pull-left f-bold-dubai">Apply Filter(s)</h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalfilterRef.hide();clearNewFilter();">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body py-3">
    <div class="row">
      <div class="col-md-6">
        <div class="form-group">
          <label>Keyword</label>
          <input type="text" [(ngModel)]="keyword" class="form-control" placeholder="Enter Keyword(s)">
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6">
        <div class="form-group">
          <label>Date</label>
          <input type="text" onfocus="(this.type='date')" placeholder="MM/DD/YYYY" [(ngModel)]="startDate" class="form-control" >
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <label>&nbsp;</label>
          <input type="text" onfocus="(this.type='date')" placeholder="MM/DD/YYYY"  [(ngModel)]="endDate" class="form-control" >
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6">
        <div class="form-group">
          <label>Status</label>
          <ng-select [items]="statusList" 
                     bindLabel="status"
                     bindValue="value"
                     [(ngModel)]="status"
                     id="status"
                     name="status"
                     [multiple]="false"
                     [searchable]="true"
                     [virtualScroll]="true"
                     [minTermLength]="3"
                     placeholder="Status">
          </ng-select>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6">
        <div class="form-group">
          <label>Initiated By (User)</label>
          <ng-select [items]="UserList" 
                     bindLabel="fullAttendeeName"
                     bindValue="userselUno"
                     [(ngModel)]="initiatedBy"
                     id="initiated"
                     name="initiated"
                     [multiple]="false"
                     [searchable]="true"
                     [virtualScroll]="true"
                     [minTermLength]="3"
                     placeholder="Initiated By (User)">
          </ng-select>
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <label>Action Assigned To</label>
          <ng-select [items]="UserList" 
                     bindLabel="fullAttendeeName"
                     bindValue="userselUno"
                     [(ngModel)]="assignedTo"
                     id="actionAssignedTo"
                     name="actionAssignedTo"
                     [multiple]="false"
                     [searchable]="true"
                     [virtualScroll]="true"
                     [minTermLength]="3"
                     placeholder="Action Assigned To">
          </ng-select>
        </div>
      </div>
    </div>
   
    <div class="row">
      <div class="col-md-12">
        <p>Priority</p>
        <ul class="list-inline filter-btn">
          <li class="list-inline-item d-none"></li>
          <li class="list-inline-item" ngClass="{{filterVal.meetingPriority==0?'active':''}}" (click)="priority(0)">All</li>
          <li class="list-inline-item" ngClass="{{filterVal.meetingPriority==1?'active':''}}" (click)="priority(1)">Important</li>
          <li class="list-inline-item" ngClass="{{filterVal.meetingPriority==2?'active':''}}" (click)="priority(2)">Normal</li>
          <li class="list-inline-item d-none"></li>
        </ul>
      </div>
    </div>

    </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-outline-secondary f-bold-dubai px-sm-4 text-uppercase mx-3" (click)="modalfilterRef.hide();clearNewFilter();">Clear All</button>
        <button type="button" class="btn btn-success f-bold-dubai px-sm-4 text-uppercase" (click)="applyFilter();modalfilterRef.hide();">Apply Filter</button>
      </div>
</ng-template>

<ng-template #template1>
  <div class="modal-header border-0 pb-0">
    <div class="custom-tab d-block w-100">
      <button type="button" class="close hide close-abs pull-right text-right" id="editclose" name="editclose" #editclose aria-label="Close" (click)="filterVal.startIndex = 1;modalMeeting.hide();isLoader=false;">
        <span aria-hidden="true"></span>
      </button>

    </div>
  </div> 
    <app-view-meeting pagetype="MEETING" [viewType]="viewType" [mid]="mid" [inpUserList]="UserList" (editPopUpClose)="getPopUpOutput($event)"></app-view-meeting>
 </ng-template>

<ng-template #template>
  <div class="modal-header pb-0">
    <div class="custom-tab d-block w-100">
      <h4 class="modal-title text-left px-2 f-bold-dubai pb-3">{{modalText}}</h4>
      <!--<small class="px-2"><a class="text-secondary" (click)="filterVal.startIndex = 1;modalRef.hide();loadGeneralInfo();"><i class="ti ti-arrow-left"></i> Back to Meeting Minutes</a></small>-->
      <button type="button" class="close close-abs text-right" id="addclose" name="addclose" #addclose aria-label="Close" (click)="filterVal.startIndex = 1;modalRef.hide();loadGeneralInfo();">
        <span aria-hidden="true"><i class="la la-close"></i></span>
      </button>

    </div>
  </div>
    <app-add-meeting pagetype="MEETING" [meetingEditUno]="meetingEditUno" [inpUserList]="UserList"></app-add-meeting>

</ng-template>
<div class="bg-light border-bottom" id="mettingTop">
  <div class="container-fluid clearfix">

    <div class="float-md-right float-sm-right float-xs-right top-nav-btn res-fixed-x-space">
      <div class="d-inline-block mx-1 py-2">
        <button type="button" (click)="exportXL()" class="h-38 px-3 btn text-left btn-block d-sm-block btn-outline-light-gray font-weight-bold position-relative"><i class="ti ti-export pr-1 fs-14"></i> Export</button>
      </div>
      <div class="d-inline-block mx-1 py-2 drop-minus-top">
        <select id="inputState" (change)="onChangeSortBy($event.target.value)"
                class="pl-3 pr-4 btn-block d-sm-block form-control font-weight-bold grey-border btn-select">
          <option selected value="date">Sort by Created</option>
          <option value="meetingdate">Sort by Meeting Date</option>
          <option value="subject">Sort by Subject</option>
          <option value="meetingName">Sort by Meeting Type</option>
          <option value="locationName">Sort by Location</option>
          <option value="approvalStatus">Sort by Status</option>
        </select>
      </div>
      <div class="d-inline-block mx-1 py-2 hide-dropdown filter-overflow" >
        <button type="button" class="h-38 px-3 btn text-left btn-block d-sm-block btn-outline-light-gray font-weight-bold position-relative" [ngClass]="filterClass" (click)="openFilter(modalfilter)"><i class="la la-filter pr-1"></i> Filter ({{filterCount}})</button>
          <!--<button type="button" class="px-3 btn btn-sm text-left btn-block d-sm-block btn-outline-light-gray font-weight-bold" ngbDropdownToggle>
    <i class="la la-filter"></i> Filter ({{filterCount}})
  </button>
  <ul ngbDropdownMenu aria-labelledby="dropdownBasic1" class="keep-open" id="drophide">
    <li><a ngbDropdownItem class="form-check px-3" (click)="filterVal.forOwner=!filterVal.forOwner;loadFilterValues()"><input class="form-check-input minus-5" type="checkbox" name="created" [(ngModel)]="created" value="" id="Created"><label class="form-check-label px-3" (click)="filterVal.forOwner=!filterVal.forOwner;loadFilterValues()" for="Created">Created by Me</label>  </a></li>

    <li><a ngbDropdownItem class="form-check px-3" (click)="filterVal.forReview=!filterVal.forReview;loadFilterValues()"><input class="form-check-input minus-5" type="checkbox" name="review" [(ngModel)]="review" value="" id="Review"><label class="form-check-label px-3" (click)="filterVal.forReview=!filterVal.forReview;loadFilterValues()" for="Review">Waiting For Review</label>  </a></li>

    <li><a ngbDropdownItem class="form-check px-3" (click)="filterVal.forApprove=!filterVal.forApprove;loadFilterValues()"><input class="form-check-input minus-5" type="checkbox" name="approval" [(ngModel)]="approval" value="" id="Approval"><label class="form-check-label px-3" (click)="filterVal.forApprove=!filterVal.forApprove;loadFilterValues()" for="Approval">Waiting For Approval</label>  </a></li>

    <li><a ngbDropdownItem class="form-check px-3" (click)="filterVal.forPublish=!filterVal.forPublish;loadFilterValues()"><input class="form-check-input minus-5" type="checkbox" name="publish" [(ngModel)]="publish" value="" id="Publish"><label class="form-check-label px-3" (click)="filterVal.forPublish=!filterVal.forPublish;loadFilterValues()" for="Publish">Waiting For Publish</label>  </a></li>

    <li><a ngbDropdownItem class="form-check px-3" (click)="filterVal.forWithDelay=!filterVal.forWithDelay;loadFilterValues()"><input class="form-check-input minus-5" type="checkbox" name="withDelay" [(ngModel)]="withDelay" value="" id="Delayed"><label class="form-check-label px-3" (click)="filterVal.forWithDelay=!filterVal.forWithDelay;loadFilterValues()" for="Delayed">With Delayed Actions</label>  </a></li>

    <li><a ngbDropdownItem class="form-check px-3" (click)="filterVal.forAction=!filterVal.forAction;loadFilterValues()"><input class="form-check-input minus-5" type="checkbox" name="assinedMe" [(ngModel)]="assinedMe" value="" id="ActionAssinged"><label class="form-check-label px-3" (click)="filterVal.forAction=!filterVal.forAction;loadFilterValues()" for="ActionAssinged">Action Assigned To Me</label>  </a></li>

    <li><a ngbDropdownItem class="form-check px-3" (click)="filterVal.forReviewAssigned=!filterVal.forReviewAssigned;loadFilterValues()"><input class="form-check-input minus-5" type="checkbox" name="ReviewActionAssinged" [(ngModel)]="reviewAssignedTodMe" value="" id="ReviewActionAssinged"><label class="form-check-label px-3" (click)="filterVal.forReviewAssigned=!filterVal.forReviewAssigned;loadFilterValues()" for="ActionAssinged">Review Assigned To Me</label>  </a></li>

    <li><a ngbDropdownItem class="form-check px-3" (click)="filterVal.forApprovalAssigned=!filterVal.forApprovalAssigned;loadFilterValues()"><input class="form-check-input minus-5" type="checkbox" name="ApprovalActionAssinged" [(ngModel)]="approvalAssignedTodMe" value="" id="ApprovalActionAssinged"><label class="form-check-label px-3" (click)="filterVal.forApprovalAssigned=!filterVal.forApprovalAssigned;loadFilterValues()" for="ActionAssinged">Approval Assigned To Me</label>  </a></li>

    <li><a ngbDropdownItem class="form-check px-3" (click)="filterVal.forPublishOnly=!filterVal.forPublishOnly;loadFilterValues()"><input class="form-check-input minus-5" type="checkbox" name="publishOnly" [(ngModel)]="publishOnly" value="" id="publishOnly"><label class="form-check-label px-3" (click)="filterVal.forPublishOnly=!filterVal.forPublishOnly;loadFilterValues()" for="Published">Published</label>  </a></li>


    <li><a ngbDropdownItem class="form-check px-3" (click)="filterVal.forDelay=!filterVal.forDelay;loadFilterValues()"><input class="form-check-input minus-5" type="checkbox" name="delay" [(ngModel)]="delay" value="" id="Delay"><label class="form-check-label px-3" (click)="filterVal.forDelay=!filterVal.forDelay;loadFilterValues()" for="Delay">For Delayed more than 3 days</label>  </a></li>
    <li><a ngbDropdownItem (click)="clearAllFilter()"><i class="la la-close minus-5"></i> Clear All</a></li>
  </ul>-->
</div>
    </div>
  </div>
</div>

<div class="container-fluid py-3 px-4 left-menu-space" id="divMainContainer">

  <div class="page-title-box d-sm-flex justify-content-between bd-highlight">
    <h4 class="mb-0 f-bold-dubai text-secondary pb-2">Meeting Minutes</h4>
    <div class="page-title-right pb-2">
      <a class="btn btn-success text-white py-2 px-3" (click)="openModal(template,0)"><i class="fa fa-plus pr-1"></i> NEW MEETING MINUTES</a>
    </div>
  </div>
  <div class="py-2">
    <ul class="list-inline filter-btn">
      <li class="list-inline-item px-0 mx-0"><b>Smart Filters:</b></li>
      <li class="list-inline-item" ngClass="{{filterVal.forOwner || actionType =='createdby'?'active':''}}" (click)="filterVal.forOwner=!filterVal.forOwner;loadFilterValues()">Created by Me</li>
      <li class="list-inline-item" ngClass="{{filterVal.forReview || actionType =='approval'?'active':''}}" (click)="filterVal.forReview=!filterVal.forReview;loadFilterValues()">Waiting For Review</li>
      <li class="list-inline-item" ngClass="{{filterVal.forApprove || actionType =='approval'?'active':''}}" (click)="filterVal.forApprove=!filterVal.forApprove;loadFilterValues()">Waiting For Approval</li>
      <li class="list-inline-item" ngClass="{{filterVal.forPublishOnly || actionType =='published'?'active':''}}" (click)="filterVal.forPublishOnly=!filterVal.forPublishOnly;loadFilterValues()">Published</li>
      <li class="list-inline-item" ngClass="{{filterVal.forWithDelay?'active':''}}" (click)="filterVal.forWithDelay=!filterVal.forWithDelay;loadFilterValues()">With Delayed Actions</li>
      <li class="list-inline-item" (click)="clearAllFilter()">Clear All</li>
      <li class="list-inline-item nav-item" ngbDropdown>
        <a class="nav-link p-0" id="dropdownBasic1" ngbDropdownToggle>+ More Filters</a>
        <ul ngbDropdownMenu aria-labelledby="dropdownBasic1">
          <li><a ngbDropdownItem (click)="filterVal.forImp=!filterVal.forImp;loadFilterValues()">Important</a></li>
          <li><a ngbDropdownItem (click)="filterVal.forPublish=!filterVal.forPublish;loadFilterValues()">Waiting For Publish</a></li>
          <li><a ngbDropdownItem (click)="filterVal.forAction=!filterVal.forAction;loadFilterValues()">Action Assigned To Me</a></li>
          <li><a ngbDropdownItem (click)="filterVal.forReviewAssigned=!filterVal.forReviewAssigned;loadFilterValues()">Review Assigned To Me</a></li>
          <li><a ngbDropdownItem (click)="filterVal.forApprovalAssigned=!filterVal.forApprovalAssigned;loadFilterValues()">Approval Assigned To Me</a></li>
          <li><a ngbDropdownItem (click)="filterVal.forDelay=!filterVal.forDelay;loadFilterValues()">For Delayed more than 3 days</a></li>

        </ul>
      </li>
    </ul>
  </div>
  <h5 class="text-secondary" *ngIf="getTodayMeeting().length>0"><b>Today</b></h5>

  <div class="bg-white p-4 text-center text-muted rounded mb-3" *ngIf="isLoader">
    <div class="loader-bg"></div>
  </div>
  <div class="bg-white py-4 text-center text-muted h-100 mb-3" *ngIf="meetingList.length ===0 && !isLoader ">
    <!--<img src="{{noDataImage}}" class="img-fluid" alt="No Data" />-->
    <h5 class="pb-4 pt-2 text-center text-secondary py-sm-5 my-sm-5">No Data Available</h5>
  </div>
  <div class="card rounded pt-2 h-100" *ngFor="let item of getTodayMeeting()">
    <div class="pt-2 px-3 pb-3 border-bottom-0">
      <ng-container *ngIf="item.approvalStatus =='Draft' && item.enteredBy ==loginUserId; else newDeb">
        <div class="cover-div w-100 h-100" (click)="openModal(template,item.genInfoAtdUno)"></div>
        <h6 class="card-title d-sm-inline d-block f-bold-dubai pr-4 pointer" (click)="openModal(template,item.genInfoAtdUno)">{{item.subjectAtd}}</h6>
      </ng-container>
      <ng-template #newDeb>
        <div class="cover-div w-100 h-100" (click)="openModalnewMeeting(template1,item,'view')"></div>
        <h6 class="card-title d-sm-inline d-block f-bold-dubai pr-4 pointer" (click)="openModalnewMeeting(template1,item,'view')">{{item.subjectAtd}}</h6>
      </ng-template>
      <div class="card-controls float-right">
        <ul class="list-inline list-badge hide-arrow-drop">
          <li *ngIf="item.impCheck == true" class="list-inline-item">
            <a data-toggle="refresh" class="card-refresh text-black text-danger" title="Important" (click)="openModalnewMeeting(template1,item)"><i class="la la-info-circle fa-lg mx-1"></i></a>
          </li>
          <li class="list-inline-item d-none-view">
            <a data-toggle="refresh" (click)="openFileModal(item)" class="card-refresh text-black mr-1 minus-5" title="Attachement"><i class="la la-paperclip fa-lg mx-1 icon-rotate"></i> <span class="minus-5">{{item.noOfFile}}</span></a>
          </li>
          <li class="list-inline-item nav-item" ngbDropdown>
            <a class="nav-link p-0" id="dropdownBasic1" ngbDropdownToggle title="Action Points"><span class="d-none-view"> Actions </span><span class="p-0 d-none-view">{{item.noOfActionPoint}}</span><i class="la la-ellipsis-v fa-lg"></i></a>
            <ul ngbDropdownMenu aria-labelledby="dropdownBasic1" class="rht-symbol">
              <li *ngIf="item.published!=1 && item.enteredBy ==loginUserId"><a ngbDropdownItem (click)="openModal(template,item.genInfoAtdUno)"><i class="pt-1 pt-1 fa fa-edit wh-15"></i> Edit</a></li>
              <li *ngIf="item.published==1 && item.enteredBy ==loginUserId"><a ngbDropdownItem (click)="openModalnewMeeting(template1,item,'view')"><i class="pt-1 pt-1 fa fa-edit wh-15"></i> Edit</a></li>
              <li><a ngbDropdownItem (click)="openModalnewMeeting(template1,item,'view')"><i class="pt-1 fa fa-eye wh-15"></i> View</a></li>
              <li *ngIf="item.isApprover && item.published==4"><a ngbDropdownItem (click)="openModalnewMeeting(template1,item)"><i class="pt-1 fa fa-check-circle-o wh-15"></i> Approve</a></li>
              <li *ngIf="item.isReviewer && item.published==2"><a ngbDropdownItem (click)="openModalnewMeeting(template1,item)"><i class="pt-1 fa fa-check-circle-o wh-15"></i> Review</a></li>
              <li *ngIf="(item.workFlowCondition1 || item.published==5) && item.enteredBy ==loginUserId"><a ngbDropdownItem (click)="openModalnewMeeting(template1,item)"><i class="pt-1 fa fa-check-circle-o wh-15"></i> Publish</a></li>
              <li *ngIf="item.enteredBy ==loginUserId"><a ngbDropdownItem (click)="copyMeeting(item.genInfoAtdUno)"> <i class="pt-1 fa fa-clone wh-15"></i> Copy</a></li>
              <li *ngIf="item.enteredBy ==loginUserId"><a ngbDropdownItem (click)="followupMeeting(item.genInfoAtdUno)"><i class="pt-1 fa fa-mail-reply-all wh-15"></i> Follow-up</a></li>
              <li *ngIf="item.enteredBy ==loginUserId"><a ngbDropdownItem (click)="deleteMeeting(item.genInfoAtdUno)"><i class="pt-1 fa fa-trash-o wh-15"></i> Delete</a></li>

            </ul>
          </li>
        </ul>
      </div>
      <div class="py-1">
        <span class="text-secondary" *ngIf="item.approvalStatus =='Draft'">{{item.approvalStatus}}</span>
        <span class="text-warning" *ngIf="item.approvalStatus =='Under Review' || item.approvalStatus =='Reviewed'">{{item.approvalStatusView}}</span>
        <span class="text-primary" *ngIf="item.approvalStatus =='Approved'|| item.approvalStatus == 'Pending Approval'">{{item.approvalStatusView}}</span>
        <span class="text-success" *ngIf="item.approvalStatus =='Published'">{{item.approvalStatus}}</span>
      </div>
      <div class="p-0 sm-small-size">
        <span class="pr-2"><i class="la la-calendar-o fa-lg"></i><span class="d-day">{{item.fMeetingDateAtd |  date:'EEE'}}</span>   {{item.fMeetingDateAtd |  date:'dd/MM/yyyy'}}  <span class="d-time">{{item.fStartTimeAtd | timeFormat}} - {{item.fEndTimeAtd | timeFormat}}</span></span> |<span class="px-2"><i class="fa fa-group"></i> {{item.meetingName}}</span>|  <span class="px-2"><i class="la la-map-marker fa-lg"></i> {{item.locationName !=''?item.locationName:'NA'}}</span> | <span class="px-2"><b class="text-secondary">Initiator:</b> {{item.initiatedBy}}</span>
      </div>
    </div>
  </div>

  <h5 class="text-secondary" *ngIf="getYesterdayMeeting().length>0"><b>Yesterday</b></h5>
  <div class="card rounded pt-2 h-100" *ngFor="let item of getYesterdayMeeting()">
    <div class="pt-2 px-3 pb-3 border-bottom-0">
      
      <ng-container *ngIf="item.approvalStatus =='Draft' && item.enteredBy ==loginUserId; else newDeb">
        <div class="cover-div w-100 h-100" (click)="openModal(template,item.genInfoAtdUno)"></div>
        <h6 class="card-title d-sm-inline d-block f-bold-dubai pr-4 pointer" (click)="openModal(template,item.genInfoAtdUno)">{{item.subjectAtd}}</h6>
      </ng-container>
      <ng-template #newDeb>
        <div class="cover-div w-100 h-100" (click)="openModalnewMeeting(template1,item,'view')"></div>
        <h6 class="card-title d-sm-inline d-block f-bold-dubai pr-4 pointer" (click)="openModalnewMeeting(template1,item,'view')">{{item.subjectAtd}}</h6>
      </ng-template>
      
      <div class="card-controls float-right">
        <ul class="list-inline list-badge hide-arrow-drop">
          <li *ngIf="item.impCheck == true" class="list-inline-item">
            <a data-toggle="refresh" class="card-refresh text-black text-danger" title="Important" (click)="openModalnewMeeting(template1,item)"><i class="la la-info-circle fa-lg mx-1"></i></a>
          </li>
          <li class="list-inline-item d-none-view">
            <a data-toggle="refresh" (click)="openFileModal(item)" class="card-refresh text-black minus-5" title="Attachement"><i class="la la-paperclip fa-lg mx-1 icon-rotate"></i> <span class="minus-5">{{item.noOfFile}}</span></a>
          </li>
          <li class="list-inline-item nav-item" ngbDropdown>
            <a class="nav-link p-0" id="dropdownBasic1" ngbDropdownToggle title="Action Point"><span class="d-none-view"> Actions <span class="p-0 d-none-view">{{item.noOfActionPoint}}</span></span><i class="la la-ellipsis-v fa-lg"></i></a>
            <ul ngbDropdownMenu aria-labelledby="dropdownBasic1" class="rht-symbol">
              <li *ngIf="item.published!=1 && item.enteredBy ==loginUserId"><a ngbDropdownItem (click)="openModal(template,item.genInfoAtdUno)"><i class="pt-1 pt-1 fa fa-edit wh-15"></i> Edit</a></li>
              <li *ngIf="item.published==1 && item.enteredBy ==loginUserId"><a ngbDropdownItem (click)="openModalnewMeeting(template1,item,'view')"><i class="pt-1 pt-1 fa fa-edit wh-15"></i> Edit</a></li>
              <li><a ngbDropdownItem (click)="openModalnewMeeting(template1,item,'view')"><i class="pt-1 fa fa-eye"></i> View</a></li>
              <li *ngIf="item.isApprover && item.published==4"><a ngbDropdownItem (click)="openModalnewMeeting(template1,item)"><i class="pt-1 fa fa-check-circle-o"></i> Approve</a></li>
              <li *ngIf="item.isReviewer && item.published==2"><a ngbDropdownItem (click)="openModalnewMeeting(template1,item)"><i class="pt-1 fa fa-check-circle-o"></i> Review</a></li>
              <li *ngIf="item.workFlowCondition1 || item.published==6"><a ngbDropdownItem (click)="openModalnewMeeting(template1,item)"><i class="pt-1 fa fa-check-circle-o"></i> Publish</a></li>
              <li *ngIf="item.enteredBy ==loginUserId"><a ngbDropdownItem (click)="copyMeeting(item.genInfoAtdUno)"> <i class="pt-1 fa fa-clone"></i> Copy</a></li>
              <li *ngIf="item.enteredBy ==loginUserId"><a ngbDropdownItem (click)="followupMeeting(item.genInfoAtdUno)"><i class="pt-1 fa fa-mail-reply-all"></i> Follow-up</a></li>
              <li *ngIf="item.enteredBy ==loginUserId"><a ngbDropdownItem (click)="deleteMeeting(item.genInfoAtdUno)"><i class="pt-1 fa fa-trash-o"></i> Delete</a></li>

            </ul>
          </li>
        </ul>
      </div>
      <div class="py-1">
        <span class="text-secondary" *ngIf="item.approvalStatus =='Draft'">{{item.approvalStatus}}</span>
        <span class="text-warning" *ngIf="item.approvalStatus =='Under Review' || item.approvalStatus =='Reviewed'">{{item.approvalStatusView}}</span>
        <span class="text-primary" *ngIf="item.approvalStatus =='Approved'|| item.approvalStatus == 'Pending Approval'">{{item.approvalStatusView}}</span>
        <span class="text-success" *ngIf="item.approvalStatus =='Published'">{{item.approvalStatus}}</span>
      </div>
      <div class="p-0 sm-small-size">
        <span class="pr-2"><i class="la la-calendar-o fa-lg"></i><span class="d-day">{{item.fMeetingDateAtd |  date:'EEE'}}</span>   {{item.fMeetingDateAtd |  date:'dd/MM/yyyy'}}  <span class="d-time">{{item.fStartTimeAtd | timeFormat}} - {{item.fEndTimeAtd | timeFormat}}</span></span>|<span class="px-2"><i class="fa fa-group"></i> {{item.meetingName}}</span> |  <span class="px-2"><i class="la la-map-marker fa-lg"></i> {{item.locationName !=''?item.locationName:'NA'}}</span> | <span class="px-2"><b class="text-secondary">Initiator:</b> {{item.initiatedBy}}</span>
      </div>
    </div>
  </div>


  <h5 class="text-secondary" *ngIf="getOlderMeeting().length>0"><b>Older</b></h5>


  <div class="card rounded pt-2 h-100" *ngFor="let item of getOlderMeeting()">
    <div class="pt-2 px-3 pb-3 border-bottom-0">
      <ng-container *ngIf="item.approvalStatus =='Draft' && item.enteredBy ==loginUserId; else newDeb">
        <div class="cover-div w-100 h-100" (click)="openModal(template,item.genInfoAtdUno)"></div>
        <h6 class="card-title d-sm-inline d-block f-bold-dubai pr-4 pointer" (click)="openModal(template,item.genInfoAtdUno)">{{item.subjectAtd}}</h6>
      </ng-container>
      <ng-template #newDeb>
        <div class="cover-div w-100 h-100" (click)="openModalnewMeeting(template1,item,'view')"></div>
        <h6 class="card-title d-sm-inline d-block f-bold-dubai pr-4 pointer" (click)="openModalnewMeeting(template1,item,'view')">{{item.subjectAtd}}</h6>
      </ng-template>
      <div class="card-controls float-right">
        <ul class="list-inline list-badge hide-arrow-drop">
          <li *ngIf="item.impCheck == true" class="list-inline-item">
            <a data-toggle="refresh" class="card-refresh text-black text-danger" title="Important" (click)="openModalnewMeeting(template1,item)"><i class="la la-info-circle fa-lg mx-1"></i></a>
          </li>
          <li class="list-inline-item d-none-view">
            <a data-toggle="refresh" (click)="openFileModal(item)" class="card-refresh text-black minus-5" title="Attachement"><i class="la la-paperclip fa-lg mx-1 icon-rotate"></i> <span class="minus-5 pr-1">{{item.noOfFile}}</span></a>
          </li>
          <li class="list-inline-item nav-item" ngbDropdown>
            <a class="nav-link p-0" id="dropdownBasic1" ngbDropdownToggle title="Action Points"><span class="d-none-view"> Actions <span class="p-0 d-none-view">{{item.noOfActionPoint}}</span></span><i class="la la-ellipsis-v fa-lg"></i></a>
            <ul ngbDropdownMenu aria-labelledby="dropdownBasic1" class="rht-symbol">
              <li *ngIf="item.published!=1 && item.enteredBy ==loginUserId"><a ngbDropdownItem (click)="openModal(template,item.genInfoAtdUno)"><i class="pt-1 pt-1 fa fa-edit wh-15"></i> Edit</a></li>
              <li *ngIf="item.published==1 && item.enteredBy ==loginUserId"><a ngbDropdownItem (click)="openModalnewMeeting(template1,item,'view')"><i class="pt-1 pt-1 fa fa-edit wh-15"></i> Edit</a></li>
              <li><a ngbDropdownItem (click)="openModalnewMeeting(template1,item,'view')"><i class="pt-1 fa fa-eye"></i> View</a></li>
              <li *ngIf="item.isApprover && item.published==4"><a ngbDropdownItem (click)="openModalnewMeeting(template1,item)"><i class="pt-1 fa fa-check-circle-o"></i> Approve</a></li>
              <li *ngIf="item.isReviewer && item.published==2"><a ngbDropdownItem (click)="openModalnewMeeting(template1,item)"><i class="pt-1 fa fa-check-circle-o"></i> Review</a></li>
              <li *ngIf="item.workFlowCondition1 || item.published==6"><a ngbDropdownItem (click)="openModalnewMeeting(template1,item)"><i class="pt-1 fa fa-check-circle-o"></i> Publish</a></li>
              <li *ngIf="item.enteredBy ==loginUserId"><a ngbDropdownItem (click)="copyMeeting(item.genInfoAtdUno)"> <i class="pt-1 fa fa-clone"></i> Copy</a></li>
              <li *ngIf="item.enteredBy ==loginUserId"><a ngbDropdownItem (click)="followupMeeting(item.genInfoAtdUno)"><i class="pt-1 fa fa-mail-reply-all"></i> Follow-up</a></li>
              <li *ngIf="item.enteredBy ==loginUserId"><a ngbDropdownItem (click)="deleteMeeting(item.genInfoAtdUno)"><i class="pt-1 fa fa-trash-o"></i> Delete</a></li>
            </ul>
          </li>
        </ul>
      </div>
      <div class="py-1">
        <span class="text-secondary" *ngIf="item.approvalStatus =='Draft'">{{item.approvalStatus}}</span>
        <span class="text-warning" *ngIf="item.approvalStatus =='Under Review' || item.approvalStatus =='Reviewed'">{{item.approvalStatusView}}</span>
        <span class="text-primary" *ngIf="item.approvalStatus =='Approved'|| item.approvalStatus == 'Pending Approval'">{{item.approvalStatusView}}</span>
        <span class="text-success" *ngIf="item.approvalStatus =='Published'">{{item.approvalStatus}}</span>
      </div>
      <div class="p-0 sm-small-size">
        <span class="pr-2"><i class="la la-calendar-o fa-lg"></i><span class="d-day">{{item.fMeetingDateAtd |  date:'EEE'}}</span>   {{item.fMeetingDateAtd |  date:'dd/MM/yyyy'}}  <span class="d-time">{{item.fStartTimeAtd | timeFormat}} - {{item.fEndTimeAtd | timeFormat}}</span></span>|<span class="px-2"><i class="fa fa-group"></i> {{item.meetingName}}</span> |  <span class="px-2"><i class="la la-map-marker fa-lg"></i> {{item.locationName !=''?item.locationName:'NA'}}</span> | <span class="px-2"><b class="text-secondary">Initiator:</b> {{item.initiatedBy}}</span>
      </div>
    </div>
  </div>


  <div class="text-center" *ngIf="!disableMore"><a class="btn btn-sm btn-outline-secondary" (click)="loadGeneralInfo()">Load More..</a></div>
  <div style="display:none">
    <quill-editor theme="snow" id="note" class="custom-form-control" style="background-color:#f1f1f1"
                  name="note" placeholder="Enter your text here">
    </quill-editor>
  </div>
</div>

<ng-template #templateFile>
  <div class="modal-header">
    <h4 class="modal-title pull-left f-bold-dubai">File Attachment</h4>

    <button type="button" class="close pull-right" aria-label="Close" (click)="modalPub.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="row">
      <div class="col-md-12 px-2 pb-70">
        <div class="bg-white py-4 text-center text-muted h-100 mb-3" *ngIf="fileList.length ===0">
  <!--<img src="{{noDataImage}}" class="img-fluid" alt="No Data" />-->
          <h5>No Data Available</h5>
</div>
        <div class="p-3 border rounded-bottom rounded-right bg-light my-3" *ngFor="let objFile of fileList">
          <span class="text-secondary f-bold-dubai pr-2">{{objFile.createByName}}</span> <small class="text-muted">{{objFile.createDate | date:'dd/MM/yyyy h:mm a '}}</small>
          <div class="attachement-card rounded p-2 mt-2">
            <i class="la fa-lg " [ngClass]="checkFileType(objFile.fileName)"></i> {{objFile.fileName}}
            <div class="card-controls float-right text-secondary pt-1">
              <ul class="list-inline list-badge hide-arrow-drop">

                <li class="list-inline-item nav-item" ngbDropdown>
                  <a class="nav-link p-0" id="dropdownBasic1" ngbDropdownToggle><i class="la la-ellipsis-v fa-lg"></i></a>
                  <ul ngbDropdownMenu aria-labelledby="dropdownBasic1">
                    <li><a ngbDropdownItem (click)="DownloadFiles(objFile)"><i class="fa fa-download"></i> Download</a></li>
                  </ul>
                </li>
              </ul>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
  <div class="modal-footer border-0">
    <button type="button" class="btn btn-outline-secondary" (click)="modalPub.hide()">Close</button>

  </div>
</ng-template>
